export default "__VITE_ASSET__Beszrhwh__"